export default __webpack_public_path__ + "static/therapy2-a329cf12ceab6acbe1ffdb75efc1b17e.webp";